export var CREDITS = 1;
export var CREDITCARD = 3;
export var FREE = 4;
export var PAYPAL = 6;
export var BANK_TRANSFER = 9;
export var ALIPAY = 19;
export var BOLETO = 20;
export var UNIONPAY = 21;
export var ALLPAGOPAYPAL = 22;
export var ALLPAGOCREDITCARD = 23;
export var WECHAT = 25;
export var VOUCHER = 26;
export var WFOE_WEBPAY = 27;
export var WFOE_QRCODE_PAY = 28;
var EXTERNAL_THIRD_PARTY_PAYMENT_SITES = {};
EXTERNAL_THIRD_PARTY_PAYMENT_SITES[ALIPAY] = 'Alipay';
EXTERNAL_THIRD_PARTY_PAYMENT_SITES[PAYPAL] = 'PayPal';
EXTERNAL_THIRD_PARTY_PAYMENT_SITES[ALLPAGOPAYPAL] = 'PayPal';
EXTERNAL_THIRD_PARTY_PAYMENT_SITES[UNIONPAY] = 'UnionPay';
EXTERNAL_THIRD_PARTY_PAYMENT_SITES[WECHAT] = 'WeChat';
EXTERNAL_THIRD_PARTY_PAYMENT_SITES[WFOE_WEBPAY] = 'WFOE Web Pay';
EXTERNAL_THIRD_PARTY_PAYMENT_SITES[WFOE_QRCODE_PAY] = 'WFOE QRCode Pay';
var SUPPORTS_FAPESP = [CREDITCARD, BANK_TRANSFER];
export var paymentMethodSupportsFapesp = function paymentMethodSupportsFapesp(paymentMethodId) {
  return SUPPORTS_FAPESP.indexOf(paymentMethodId) !== -1;
};
var ALLPAGO_METHODS = [ALLPAGOCREDITCARD, ALLPAGOPAYPAL, BOLETO];
export var isAllpagoPaymentMethod = function isAllpagoPaymentMethod(paymentMethodId) {
  return ALLPAGO_METHODS.indexOf(paymentMethodId) !== -1;
};
var SUPPORTS_CURRENCY_SELECTION = [CREDITCARD];
export var paymentMethodSupportsCurrencySelection = function paymentMethodSupportsCurrencySelection(paymentMethodId) {
  return SUPPORTS_CURRENCY_SELECTION.indexOf(paymentMethodId) !== -1;
};
var SUPPORTS_FAPIAO = [ALIPAY, UNIONPAY, BANK_TRANSFER];
export var paymentMethodSupportsFapiao = function paymentMethodSupportsFapiao(paymentMethodId) {
  return SUPPORTS_FAPIAO.indexOf(paymentMethodId) !== -1;
};
var REQUIRES_ORGANIZATION = [BANK_TRANSFER, ALLPAGOCREDITCARD, ALLPAGOPAYPAL];
export var paymentMethodRequiresOrganization = function paymentMethodRequiresOrganization(paymentMethodId) {
  return REQUIRES_ORGANIZATION.indexOf(paymentMethodId) !== -1;
};
var REQUIRES_PHONE_NUMBER = [ALLPAGOPAYPAL, ALIPAY, UNIONPAY, WECHAT, BANK_TRANSFER];
export var paymentMethodRequiresPhoneNumber = function paymentMethodRequiresPhoneNumber(paymentMethodId) {
  return REQUIRES_PHONE_NUMBER.indexOf(paymentMethodId) !== -1;
};
export var paymentMethodRequiresBillingInformation = function paymentMethodRequiresBillingInformation(paymentMethodId) {
  return [WFOE_QRCODE_PAY, WFOE_WEBPAY].indexOf(paymentMethodId) === -1;
};
export var paymentMethodNameOfExternalThirdPartyPaymentSite = function paymentMethodNameOfExternalThirdPartyPaymentSite(paymentMethodId) {
  return EXTERNAL_THIRD_PARTY_PAYMENT_SITES[paymentMethodId];
};